const SPACE_LEADING_REGEXP = /(?=\S)[^\\]/;

class SpaceLeadingPatternDirective {
  constructor() {
    this.require = 'ngModel';
    this.restrict = 'A';
    this.link = (...args) => {
      args[3].$validators.spaceLeadingPattern = (value) => SPACE_LEADING_REGEXP.test(value) || !value;
    };
  }
}

export default SpaceLeadingPatternDirective;



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-validators/space-leading-pattern/space-leading-pattern-directive.js